

define(['squid/index', 'text!./template.html', './opinionlab', './footerMap', 'components/xo-models/src/checkout/index', 'components/xo-ui-components/src/modal/directive', 'components/xo-return-to-merchant/dist/util', 'components/xo-ui-components/src/escape-hatch/escapeHatch/directive', 'components/xo-device-info/dist/index', 'components/xo-form-components/src/language-options/directive', 'components/xo-models/src/user/index', 'components/xo-models/src/auth/index'], function (squid, template, opinionlab, footerMap) {
    squid.module('xo-footer.directive', ['squid', 'xomodel.checkout', 'xo-modal.directive', 'xo-return-to-merchant', 'xo-escape-hatch.escapeHatch.directive', 'xo-device-info', 'xo-language-options.directive', 'xomodel.user']).directive('xoFooter', function () {

        return {
            template: template,
            restrict: 'EA',
            scope: {
                token: '=',
                escapeHatchIncontext: '=',
                cancel: '@',
                merchant: '@',
                languageSwitch: '=?',
                showVenmoLegalLinks: '='
            },
            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $CheckoutPayeeModel, $ReturnToMerchant, $util, $integration, $locale, $window, $DeviceInfo, $feature, $config, $state, $CheckoutInputDataModel, $AuthModel) {

                $scope.isIFrame = $util.isIFrame();
                if ($scope.escapeHatchIncontext) {
                    $scope.showEscapeHatch = $scope.isIFrame;
                }
                $scope.locale = $locale;
                $scope.proxSignUpFlow = $CheckoutInputDataModel.instance($scope.token).isEbayTxn();
                $scope.year = new Date().getFullYear();

                $scope.isApac = function () {
                    return $config.apacCountries && $config.apacCountries.indexOf($scope.locale.country) > -1;
                };

                // Determine if country belongs to a region to serve correct footer links
                var getRegion = function getRegion(country) {
                    var regions = $config.regions;
                    for (var region in regions) {
                        if (regions[region].indexOf(country) > -1) {
                            return region;
                        }
                    }
                    return false;
                };

                function isDESecondButtonFlow() {
                    return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
                }

                $scope.footerLinks = function () {

                    if ($scope.isApac()) {
                        return footerMap.APAC;
                    }

                    // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
                    // that were available in Aries
                    if (isDESecondButtonFlow()) {
                        return footerMap['DESecondButton'];
                    }

                    return footerMap[$scope.locale.country] || footerMap[getRegion($scope.locale.country)] || footerMap.DEFAULT;
                };

                $scope.showPolicyInfo = function () {
                    return $scope.isApac() || $scope.locale.country === 'AU';
                };

                $scope.cancelRedirect = function ($event) {
                    $event.preventDefault();

                    var cancelUri = $scope.cancel;
                    var redirectUri;

                    // "redirect_uri" as a query param overrides the cancel url in the checkout session
                    if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
                        redirectUri = $util.param('redirect_uri');

                        cancelUri = $util.buildURL(redirectUri, {
                            opType: 'cancel',
                            return_uri: $scope.cancel,
                            token: $scope.token
                        });
                    }

                    $ReturnToMerchant.goTo(cancelUri);
                };

                $scope.isIndiaLegalEntity = function () {
                    // for PayPal India domestic launch legal entity should be 84
                    // update footer with indian policy for this case
                    return $scope.auth && $scope.auth.logged_in && $scope.auth.legalEntity === 84;
                };

                if ($scope.token) {
                    $populate($scope, {
                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                        checkoutPayee: $CheckoutPayeeModel.instance($scope.token),
                        auth: $AuthModel.instance()
                    }).then(function () {
                        var merchant = $scope.checkoutAppData.merchant;

                        var payee = $scope.checkoutPayee;

                        if (payee && payee.merchant && payee.merchant.id) {
                            var hcl = $config.hideCancelLinkForMerchant;

                            var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
                            if (shouldHide) {
                                $scope.hideCancel = true;
                            }
                        }
                        $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
                        $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

                        // for ebay transactions, override the merchant name to ebay instead of the actual merchant.
                        if ($scope.proxSignUpFlow) {
                            $scope.merchant = $locale.content.signup.ebay;
                        }
                    });
                }

                var cancelShowModal = $rootScope.$on('showModal', function (event, config) {
                    $scope.popupUrl = config && config.popupUrl;
                    $scope.show = true;
                    $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                });

                $scope.$on('$destroy', cancelShowModal);

                $scope.showOL = function showOL(event) {
                    event.preventDefault();

                    var placeholder = 'main:ec:hermes';
                    var page = $state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);

                    var data = {
                        opVars: {
                            rlogId: $window.meta.rlogId || '',
                            page: page || window.location.hash,
                            csci: 'Unknown',
                            calc: $window.meta.correlationId,
                            custId: 'Unknown',
                            merchantId: 'Unknown',
                            token: $scope.token || 'Unknown'
                        },
                        locale: {
                            country: $locale.country,
                            languageCode: $locale.lang + '_' + $locale.country
                        }
                    };

                    opinionlab(data);
                };

                $scope.showFeedback = function () {
                    return !$DeviceInfo.isDevice() && !isDESecondButtonFlow();
                };

                $scope.hideReturnCancelUrl = function () {
                    return !$scope.cancel || $state.current && $state.current.name === 'checkout.done';
                };

                $scope.showVenmoLinks = function () {
                    // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
                    if ($state.current && $state.current.name === 'checkout.payWithSelection') {
                        return true;
                    } else {

                        return Boolean($scope.showVenmoLegalLinks);
                    }
                };

                $scope.showPaypalLinks = function () {
                    // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links

                    if ($state.current && $state.current.name === 'checkout.payWithSelection') {
                        return true;
                    } else {

                        return !Boolean($scope.showVenmoLegalLinks);
                    }
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/footer/directive.js
// module id = ./components/xo-page-components/src/footer/directive.js
// module chunks = 1